import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';

const PriceG = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={`${styles.containerInline} ${styles.sizeBodyText} ${color ? styles[color] : ''}`}>
		  <div className={styles.prices}>
			  {priceData.price} {priceData.curr}
		  </div>
	  </div>
	);
}

PriceG.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceG;
